  <template>
    <div>
      <Toast />
      <div class="wrapper">
        <div class="sidebar">
          <AuthSidebar />
        </div>
        <div class="form-wrapper">
          <div class="form">
            <form @submit.prevent="handleSubmit()" v-if="!isCode">
              <div v-if="!isMail">
                <h1 class="">Mail Confirmation</h1>
                <p>Enter the 6-digit code sent to your email</p>
                <div class="d-flex flex-column" style="gap: 15px">
                  <InputText v-model="v$.email.$model" :label="'Email'" :type="'email'"
                    :placeholder="'Enter your email'" class="w-100"
                    :class="{ 'p-invalid': v$.email.$error && submitted }" />
                  <Button :type="'button'" :label="'Send'" icon="pi pi-angle-right" iconPos="right" @click="SendCode"
                    class="w-100" />
                </div>
              </div>
              <div class="otp-container" v-if="isMail">
                <div class="otp-input-group">
                  <input v-for="(digit, index) in otp" :key="index" type="text" :maxlength="1" v-model="otp[index]"
                    @input="onInput(index, $event.target.value)" :ref="'otpInput' + index" @paste="onPaste" />
                  <Button :type="'submit'" :label="'Submit'" icon="pi pi-angle-right" iconPos="right"
                    :disabled="otp.some((digit) => digit === '')" />
                </div>
              </div>
            </form>
            <div v-else class="loading-wrapper">
              <div class="splash-screen">
                <div class="splash-loader-container">
                  <svg class="splash-loader" width="65px" height="65px" viewBox="0 0 66 66"
                    xmlns="http://www.w3.org/2000/svg">
                    <circle class="splash-path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33"
                      r="30"></circle>
                  </svg>
                </div>
              </div>
              <h2 v-if="successMassage.length > 0">
                {{ successMassage }}
              </h2>
              <Skeleton v-else class="w-100 h-100" />
            </div>

          </div>
        </div>
      </div>
    </div>
  </template>

<script>
import AuthSidebar from "../components/AuthSidebar.vue";
import { required, email } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import { post } from "../api/Services";
import { mapState } from "vuex";
import { setItem } from "../store/localStorage";


export default {
  components: {
    AuthSidebar,
  },
  data() {
    return {
      otp: Array(6).fill(""),
      focusedIndex: 0,
      step: 0,
      isMail: false,
      email: "",
      submitted: false,
      params: {},
      isCode: false,
      successMassage: "",
    };
  },
  validations: {
    email: {
      email,
      required,
    },
  },

  created() {
    if (this.$route.query.email) {
      this.email = this.$route.query.email;
      this.isMail = true;
    }
    if (this.$route.query.email && this.$route.query.code) {
      this.email = this.$route.query.email;
      this.otp = this.$route.query.code.split("");
      this.isCode = true;
      this.handleSubmit();
    }

  },
  setup: () => ({ v$: useVuelidate() }),
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
  },
  methods: {
generateSeoUrl(text) {
  return text
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9 ]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
},
    randomString(length) {
      let result = '';
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    },

    async handleSubmit() {
      this.submitted = true;
      if (!this.email || this.otp.every((digit) => digit === "")) {
        return;
      }
      const code = this.otp.join("");
      this.params.userId = -1;
      this.params.sqlId = 56;
      const parameters = [
        //{ parameter_name: "pin_user_id", parameter_value: -1 },
        { parameter_name: "piv_email", parameter_value: this.email },
        {
          parameter_name: "piv_email_confirmation_code",
          parameter_value: code,
        },
      ];
      this.params.parameters = JSON.stringify(parameters);
      try {
        const data = await post("Commons/Executer", this.params);
        if (data[0].status == 0) {
          if (!this.isCode) {
            this.$toast.add({
              severity: "success",
              summary: "Success",
              detail: data[0].message,
              life: 3000,
            });
          }
          this.successMassage = data[0].message;
          this.account.emailConfirmed = this.randomString(10);
          setItem("emailConfirmed", this.account.emailConfirmed);


          setTimeout(() => {
            this.$router.push({
              name: 'login',
              query: {
                status: this.account.emailConfirm,
                message: this.generateSeoUrl(data[0].message),
                severity: 'success'
              }
            });
          }, 3000);

        }
        else {
          this.isCode = false;
          this.otp = Array(6).fill("");
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: data[0].message,
            life: 3000,
          });
        }
      } catch (error) {
        this.isCode = false;
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: error,
          life: 3000,
        });
      }
    },

    SendCode() {
      this.submitted = true;
      if (this.v$.email.$invalid) {
        this.v$.email.$touch();
        return;
      }
      this.isMail = true;
    },
    onInput(index, value) {
      this.otp[index] = value;
      if (index < this.otp.length - 1 && value.length === 1) {
        this.focusedIndex = index + 1;
      } else if (index > 0 && value.length === 0) {
        this.focusedIndex = index - 1;
      }
    },
    onPaste(event) {
      event.preventDefault();
      const pastedData = event.clipboardData.getData('text');
      pastedData.split('').forEach((digit, index) => {
        if (index < this.otp.length) {
          this.otp[index] = digit;
        }
      });
    },
  },
  watch: {
    focusedIndex(newValue) {
      if (!this.isCode && newValue) {
        if (newValue >= 0 && newValue < this.otp.length) {
          this.$refs["otpInput" + newValue][0].focus();
        }
      }
    },


    isMail(newValue) {
      if (!this.isCode && newValue) this.$refs["otpInput" + newValue][0].focus();
    },
  },
};
</script>

<style lang="scss" scoped>
.otp-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.otp-input-group {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: repeat(2, 1fr);
  column-gap: 5px;
  row-gap: 15px;
}

.otp-input-group input {
  width: 60px;
  height: 60px;
  text-align: center;
  border: 1px solid #ccc;
  font-size: 22px;
  border-radius: 15%;
}

.otp-input-group input:focus {
  outline: none;
  border: 2px solid #007bff;
}

button.p-button {
  height: 47px !important;
  border-radius: 6px !important;
  background-color: #fc6c2a !important;
  transition: all 0.2s cubic-bezier(0.64, 0.09, 0.08, 1);
  grid-column: 1 / -1;

  &:hover,
  &:active {
    opacity: 0.8 !important;
  }

  &:disabled {
    background-color: #ccc !important;
    color: #fff !important;
  }
}

.loading-wrapper {
  position: absolute;
  inset: 0;
  z-index: 99;
  background: rgba(255, 255, 255, 0.8);
  width: 100%;
  height: 100%;

}
</style>
